export default "__VITE_ASSET__CRC1quQk__"